import { resolveIcon, externalProps } from './menuUtils';
import { Icon } from '@/components/Icon';
import type { CtaBox } from '@/types/menu';

interface MenuInfoProps {
  cta: CtaBox;
  onClose: () => void;
}

export const MenuInfo = ({ cta, onClose }: MenuInfoProps) => (
  <div className="bg-secondary-lighter mt-4 rounded-xl p-4 text-center lg:mt-0 lg:self-start">
    {cta.ctaTitle && <p className="mb-2 text-sm">{cta.ctaTitle}</p>}
    {cta.ctaText && cta.ctaLink && (
      <a
        href={cta.ctaLink}
        onClick={onClose}
        {...externalProps(cta.ctaLink)}
        className="text-primary inline-flex items-center gap-1 text-sm font-medium"
      >
        {cta.ctaIcon ? (
          <Icon src={resolveIcon(cta.ctaIcon)!} size={16} />
        ) : (
          <Icon src="/icons/svg/arrow-right.svg" size={16} />
        )}
        {cta.ctaText}
      </a>
    )}
  </div>
);
